import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import PrincipalMortgagePaymentRuleset from '../../business/ruleset/PrincipalMortgagePaymentRuleset';
import { RulesetResult } from '../../business/rules';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';

const {
  formField: { principalMortgagePayment },
} = loanFormModel;

export class PrincipalMortgagePaymentValidation implements ValidationSchema {
  public name = principalMortgagePayment.name;
  public label = principalMortgagePayment.label;
  public type = 'number';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(schema: any, ...args: any[]) {
    return schema.test({
      name: 'principalMortgagePaymentValidation',
      test: function (value, context) {
        const application: Partial<ApplicationFormValues> = this.from[1].value;

        const result: RulesetResult =
          PrincipalMortgagePaymentRuleset.setPrincipalId(
            this.parent.id
          ).evaluate(application);

        const required = !!(result & RulesetResult.REQUIRED);

        // Check if the value is null, undefined, or an empty string
        // Zero is a valid value, so we don't need to check for that
        if (
          required &&
          (value === null || value === undefined || value === '')
        ) {
          return this.createError({
            message: principalMortgagePayment.requiredErrorMsg,
          });
        }
        return true;
      },
    });
  }
}
export default new Validation(new PrincipalMortgagePaymentValidation());
